import { Controller } from "stimulus";
import {addHtmlElementClass, setHtmlElementContent} from "../utils/utils";
import I18n from "i18n-js";


export default class extends Controller {

    handleClick() {
        setHtmlElementContent(document, 'wallet_text_final', I18n.t('js.userWallet.text3'))
        addHtmlElementClass(document, 'view_more', 'd-none');
    }
}